import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve ser usado dentro de um AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(true);

  // Verificar se há token salvo no localStorage
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      // Configurar token no axios
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      
      // Buscar dados do usuário
      api.get('/auth/perfil')
        .then(response => {
          setUsuario(response.data.usuario);
        })
        .catch(error => {
          console.error('Erro ao buscar perfil:', error);
          // Token inválido, remover
          localStorage.removeItem('token');
          delete api.defaults.headers.common['Authorization'];
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, senha) => {
    try {
      const response = await api.post('/auth/login', { email, senha });
      const { usuario, token } = response.data;
      
      // Salvar token
      localStorage.setItem('token', token);
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      
      // Atualizar estado
      setUsuario(usuario);
      
      // Redirecionar baseado no nível do usuário
      setTimeout(() => {
        if (usuario.nivel === 'admin') {
          window.location.href = '/admin';
        } else {
          window.location.href = '/';
        }
      }, 100);
      
      return { success: true, usuario };
    } catch (error) {
      const mensagem = error.response?.data?.erro || 'Erro ao fazer login';
      return { success: false, error: mensagem };
    }
  };

  const registro = async (nome, email, senha) => {
    try {
      const response = await api.post('/auth/registro', { nome, email, senha });
      const { usuario, token } = response.data;
      
      // Salvar token
      localStorage.setItem('token', token);
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      
      // Atualizar estado
      setUsuario(usuario);
      
      return { success: true, usuario };
    } catch (error) {
      const mensagem = error.response?.data?.erro || 'Erro ao criar conta';
      return { success: false, error: mensagem };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    delete api.defaults.headers.common['Authorization'];
    setUsuario(null);
  };

  const isAuthenticated = () => {
    return !!usuario;
  };

  const isAdmin = () => {
    return usuario?.nivel === 'admin';
  };

  const value = {
    usuario,
    loading,
    login,
    registro,
    logout,
    isAuthenticated,
    isAdmin
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}; 